var map = {
	"./1-1.json": 7908,
	"./1-1.solution.json": 4793,
	"./1-10.json": 8628,
	"./1-10.solution.json": 9529,
	"./1-11.json": 3015,
	"./1-11.solution.json": 5716,
	"./1-2.json": 3889,
	"./1-2.solution.json": 3278,
	"./1-3.json": 8934,
	"./1-3.solution.json": 2739,
	"./1-4.json": 9739,
	"./1-4.solution.json": 2776,
	"./1-5.json": 2200,
	"./1-5.solution.json": 109,
	"./1-6.json": 3765,
	"./1-6.solution.json": 7938,
	"./1-7.json": 250,
	"./1-7.solution.json": 4967,
	"./1-8.json": 5295,
	"./1-8.solution.json": 9932,
	"./1-9.json": 6332,
	"./1-9.solution.json": 1649,
	"./2-1.json": 9369,
	"./2-1.solution.json": 8358,
	"./2-2.json": 1724,
	"./2-2.solution.json": 8961,
	"./2-3.json": 8863,
	"./2-3.solution.json": 5516,
	"./2-4.json": 3170,
	"./2-4.solution.json": 4399,
	"./2-5.json": 2605,
	"./2-5.solution.json": 202,
	"./2-6.json": 7088,
	"./2-6.solution.json": 6149,
	"./sandbox.json": 390,
	"./sandbox.solution.json": 9395
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4564;